<template>
  <Layout>
    <EntitlementPersonLayout />

    <section class="p_main">
      <div class="row">
        <div class="col-12 bg-white rounded">
          <div class="table-responsive scrollable-table" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>SL</th>
                <th>Ind. EP</th>
                <th>Ind. EC</th>
                <th>Ind. Voucher</th>
                <th>Power EP / EC / Voucher</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(payment_voucher, index) in payment_vouchers" :key="index">
                <td>{{ index + 1}}</td>
                <td>
                  <router-link :to="{ name: 'voucherEpCreate', params: { ses_id: payment_voucher.ses_id } }"
                               tag="a" target="_blank">EP File
                  </router-link>
                </td>
                <td>
                  <span v-if="payment_voucher.id">
                    <router-link :to="{ name: 'individuallyEcVoucher', params: { payment_voucher_id: payment_voucher.id } }"
                                 tag="a" target="_blank">EC
                    </router-link>
                  </span>
                  <span v-else>
                    <router-link :to="{ name: 'voucherEcCreate', params: { ses_id: payment_voucher.ses_id } }"
                                 tag="a" target="_blank">EC
                    </router-link>
                  </span>
                </td>
                <td>
                  <span v-if="payment_voucher.id">
                    <router-link :to="{ name: 'createIndividuallyVoucher', params: { payment_voucher_id: payment_voucher.id } }"
                                 tag="a" target="_blank">Voucher
                    </router-link>
                  </span>
                </td>
                <td>
                  <span v-if="payment_voucher.power_group_id != null">
                    <router-link style="margin-right: 10px" :to="{ name: 'voucherGroupEpCreate', params: { power_group_id: payment_voucher.power_group_id } }"
                                 tag="a" target="_blank">EP File
                    </router-link>

                    <router-link :to="{ name: 'voucherGroupEcCreate', params: { power_group_id: payment_voucher.power_group_id } }"
                                 tag="a" target="_blank">EC
                    </router-link>
                  </span>
                  <span v-if="payment_voucher.power_group_id != null && payment_voucher.id != null">
                    <router-link style="margin-right: 10px" :to="{ name: 'voucherGroupEpCreate', params: { power_group_id: payment_voucher.power_group_id } }"
                                 tag="a" target="_blank">EP File
                    </router-link>

                    <router-link style="margin-right: 10px" :to="{ name: 'groupEcVoucher', params: { power_group_id: payment_voucher.power_group_id } }"
                                 tag="a" target="_blank">EC
                    </router-link>

                    <router-link :to="{ name: 'createGroupVoucher', params: { power_group_id: payment_voucher.power_group_id } }"
                                 tag="a" target="_blank">Voucher
                    </router-link>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="flag === false" class="loader">Loading...</div>
            <h5 v-if="payment_vouchers.length === 0 && flag === true" class="text-center text-secondary">
              No Data Found
            </h5>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import EntitlementPersonLayout from './layout'
import http from "@state/http";

export default {
  page: {
    title: 'Entitlement Person',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, EntitlementPersonLayout },
  data() {
    return {
      title: 'Entitlement Person Payment Voucher',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Entitlement Person Payment Voucher',
          active: true,
        },
      ],
      payment_vouchers: [],
      flag: false
    }
  },
  mounted() {
    this.getPaymentVouchers();
  },

  methods: {
    getPaymentVouchers() {
      let ses_id = this.$route.params.ses_id;
      http.get("api/entitlement-person/ep-ec-voucher/list/" + ses_id).then(response => {
        if (!response.error) {
          this.flag = true;
          let data = response.data;
          this.payment_vouchers = data.payment_vouchers;
        }
      });
    }
  },
}
</script>

<style scoped>
.scrollable-table {
  overflow-x: auto;
  white-space: nowrap;
}
</style>
